export { default as Chat } from "./App.vue.js";
